import Layout from './components/Layout.jsx';
import Board from './pages/Board.jsx';
import Contact from './pages/Contact.jsx';
import FiscalSponsor from './pages/FiscalSponsor.jsx';
import Home from './pages/Home.jsx';
import NotFound from './pages/NotFound.jsx';
import OurStory from './pages/OurStory.jsx';
import Partner from './pages/Partner.jsx';
import Pillars from './pages/Pillars.jsx';
import ProjectCambodia from './pages/ProjectCambodia.jsx';
import SanFrancisco from './pages/SanFrancisco.jsx';
import WellnessWeek from './pages/WellnessWeek.jsx';

const routes = {
  '/': Home,
  '/sf': SanFrancisco,
  '/our-story': OurStory,
  '/board': Board,
  '/pillars': Pillars,
  '/wellness-week': WellnessWeek,
  '/project-cambodia': ProjectCambodia,
  '/partner': Partner,
  '/contact': Contact,
  '/fiscal-sponsor': FiscalSponsor,
};

function normalizePath(pathname) {
  if (pathname.length > 1 && pathname.endsWith('/')) return pathname.slice(0, -1);
  return pathname;
}

export default function App() {
  const path = normalizePath(window.location.pathname);
  const Page = routes[path] || NotFound;
  return <Layout path={path}><Page /></Layout>;
}
